import { RetryLink } from '@apollo/client/link/retry';

/** Operation context flag that opts a request into `unauthorizedRetryLink`. */
export const RETRY_UNAUTHORIZED = 'retryUnauthorized';

/** Jittered waits before each retry, together spanning the 2-3 s throttling bursts seen in the authorizer logs. */
const RETRY_WINDOWS_MS: readonly (readonly [number, number])[] = [
  [250, 500],
  [500, 1000],
  [1000, 2000],
];

/**
 * Retries a 401 for operations that set `RETRY_UNAUTHORIZED` in their context. The GraphQL Midway authorizers check
 * BRASS on every request with no result cache, and BRASS throttling comes back as the same 401 as a real denial,
 * which the shared `RetryLink` leaves alone.
 */
export const unauthorizedRetryLink = new RetryLink({
  attempts: (count, operation, error) =>
    count <= RETRY_WINDOWS_MS.length && operation.getContext()[RETRY_UNAUTHORIZED] === true && isUnauthorized(error),
  delay: count => {
    const [min, max] = RETRY_WINDOWS_MS[Math.min(count, RETRY_WINDOWS_MS.length) - 1] ?? [0, 0];
    return min + Math.random() * (max - min);
  },
});

function isUnauthorized(error: unknown): boolean {
  return typeof error === 'object' && error !== null && (error as { statusCode?: unknown }).statusCode === 401;
}
